import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";

import {
  employeeWorkScheduleFormOnChange,
  createEmployeeWorkScheduleOnSubmit,
} from "features/planner/employee/employee.actions";

import {
  WORK_SCHEDULE_FORM,
  CREATE_WORK_SCHEDULE_MODAL_ID,
} from "features/planner/employee/employee.constants";

import SimpleFormModal from "app/components/SimpleFormModal";
import WorkScheduleForm from "features/planner/employee/schedule/components/WorkScheduleForm";

class CreateWorkScheduleModal extends PureComponent {
  render() {
    const {
      dispatchEmployeeWorkScheduleFormOnChange,
      dispatchCreateEmployeeWorkScheduleOnSubmit,
    } = this.props;

    return (
      <SimpleFormModal
        Icon={null}
        submitText="Create"
        title="Create Work Schedule"
        component={WorkScheduleForm}
        modalId={CREATE_WORK_SCHEDULE_MODAL_ID}
        onSubmit={dispatchCreateEmployeeWorkScheduleOnSubmit}
        form={{
          form: WORK_SCHEDULE_FORM.ID,
          onChange: dispatchEmployeeWorkScheduleFormOnChange,
        }}
      />
    );
  }
}

export default compose(
  connect(
    null,
    {
      dispatchEmployeeWorkScheduleFormOnChange: employeeWorkScheduleFormOnChange,
      dispatchCreateEmployeeWorkScheduleOnSubmit: createEmployeeWorkScheduleOnSubmit,
    },
  ),
)(CreateWorkScheduleModal);
